import { getSettings } from '../services/settingsService';

const settings = getSettings();
const API_ROOT = `${settings.webApiUrl}/api/admin`;

export { API_ROOT };
